import { render, staticRenderFns } from "./NavbarAluno.vue?vue&type=template&id=01247973&scoped=true"
import script from "./NavbarAluno.vue?vue&type=script&lang=js"
export * from "./NavbarAluno.vue?vue&type=script&lang=js"
import style0 from "./NavbarAluno.vue?vue&type=style&index=0&id=01247973&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01247973",
  null
  
)

export default component.exports